import styled from 'styled-components';

const Root = styled.h6`
  margin: 0;
  height: 1.4rem;
`;

export { Root };
